import { vendorTranslations } from "./vendor-pt-br";

export const vendors_ES_MX: vendorTranslations = {
	title: "Proveedores",
	searchNamePlaceholder: "Buscar por nombre/login de proveedor",
	header: {
		create: "Crear proveedor",
		batchPermissions: "Permisos por lotes",
	},
	list: {
		vendors: "Proveedores",
		rent: "Renta",
		revenuePercentageFee: "Porcentaje de ingresos",
		tipPercentageFee: "Porcentaje de propina",
		places: "Lugares",
		fiscalProfile: "Perfil fiscal",
		login: "Login",
		paymentDaysOffset: "Días de pago",
		productsSpecialFee: "Cuota especial",
		product: "producto",
		products: "productos",
		actions: {
			editVendor: "Editar proveedor",
			deleteVendor: "Eliminar proveedor",
		},
		place: "Lugar",
		bars: "Bares",
	},
	modal: {
		close: "Cerrar",
		prevStep: "Paso anterior",
		nextStep: "Paso siguiente",
		steps: {
			dataCollection: "Datos del proveedor",
			barSelection: "Datos de lugares y bares",
			feesCalculation: "Cuotas y perfil fiscal",
			guidance: "Guía",
		},
		delete: {
			title: "Eliminar proveedor",
			description: "¿Estás seguro de querer eliminar este proveedor?",
			buttonConfirm: "Confirmar",
		},
		mode: {
			create: "Crear nuevo proveedor",
			update: "Editar proveedor",
			updateDataCollection: "Editar datos del proveedor",
			updateLinkingBarsAndLocations: "Editar lugares y bares",
			updateFeesTaxProfile: "Editar cuotas y perfil fiscal",
		},
		submit: {
			create: "Crear proveedor",
			update: "Guardar",
		},
		form: {
			required: "Campo requerido",
			nonnegative: "El valor debe ser mayor o igual a cero",
			name: {
				label: "Nombre",
				validation: "El nombre no puede estar vacío",
				placeholder: "Ingrese el nombre del proveedor",
				nonempty: "El nombre no puede estar vacío",
			},
			login: {
				label: "Login",
				validation: "El login no puede estar vacío",
				placeholder: "Ingrese el login del proveedor",
				nonempty: "El login no puede estar vacío",
				emailRegexValidation: "El login no debe ser un email",
				charactersRegexValidation:
					"El login no puede contener letras mayúsculas y caracteres especiales",
			},
			password: {
				label: "Contraseña",
				validation: "La contraseña no puede estar vacía",
				placeholder: "Ingrese la contraseña del proveedor",
				required: "Contraseña requerida",
				nonempty: "La contraseña no puede estar vacía",
			},
			places: {
				label: "Lugares",
				validation: "Selecciona al menos un lugar",
				placeholder: "Selecciona los lugares donde el proveedor estará activo",
				selectAll: "Seleccionar todos",
			},
			bars: {
				label: "Bares",
				validation: "Selecciona al menos un bar",
				placeholder: "Selecciona los bares del proveedor",
				noBars: "No bares seleccionados",
			},
			dailyRentalFeeValue: {
				label: "Cuota fija por evento",
			},
			revenuePercentageFee: {
				label: "Porcentaje de ingresos",
			},
			tipPercentageFee: {
				label: "Porcentaje de propina",
			},
			paymentDaysOffset: {
				label: "Días para realizar el pago (D+)",
				maxValidation: "Debe estar entre 0 y {{count}}",
			},
			anticipationFee: {
				label: "Cuota de anticipación",
			},
			fiscalProfileId: {
				label: "Perfil fiscal",
				placeholder: "Selecciona el perfil fiscal",
			},
			isFinancialVendor: {
				label: "Fechamentos financieros",
				description: "Generar fechamentos financieros para este proveedor",
			},
			paymentMethodFees: {
				credit: "Cuota de pago con tarjeta de crédito",
				debit: "Cuota de pago con tarjeta de débito",
				pix: "Cuota de pago con pix",
			},
			productFees: {
				productFee: "Cuota especial por producto",
				productFeePlaceholder: "Buscar un producto",
				percent: "Porcentual",
				button: "Agregar otro producto",
			},
			fullName: {
				label: "Nombre completo",
				validation: "El nombre completo no puede estar vacío",
				nonempty: "El nombre completo no puede estar vacío",
				placeholder: "Ingrese el nombre completo del proveedor",
				required: "Nombre completo requerido",
			},
			postalCode: {
				label: "Código postal",
				required: "Código postal requerido",
				invalid: "Código postal inválido",
				placeholder: "Ingrese el código postal del proveedor",
			},
			streetName: {
				label: "Nombre de la calle",
				required: "Nombre de la calle requerido",
				nonempty: "El nombre de la calle no puede estar vacío",
				placeholder: "Ingrese el nombre de la calle del proveedor",
			},
			addressNumber: {
				label: "Número",
				required: "Número requerido",
				nonempty: "El número no puede estar vacío",
				placeholder: "Ingrese el número de la calle del proveedor",
			},
			city: {
				label: "Ciudad",
				required: "Ciudad requerida",
				nonempty: "La ciudad no puede estar vacía",
				placeholder: "Ingrese la ciudad del proveedor",
			},
			state: {
				label: "Estado",
				required: "Estado requerido",
				nonempty: "El estado no puede estar vacío",
				placeholder: "Ingrese el estado del proveedor",
			},
			province: {
				label: "Bairro",
				placeholder: "Ingrese el bairro del proveedor",
				required: "Bairro requerido",
			},
			complement: {
				label: "Complemento",
				placeholder: "Ingrese el complemento del proveedor",
				required: "Complemento requerido",
			},
			phone: {
				label: "Teléfono",
				required: "Teléfono requerido",
				nonempty: "El teléfono no puede estar vacío",
				invalid: "Teléfono inválido",
				placeholder: "Ingrese el teléfono del proveedor",
			},
			email: {
				label: "Correo electrónico",
				required: "Correo electrónico requerido",
				nonempty: "El correo electrónico no puede estar vacío",
				invalid: "Correo electrónico inválido",
				placeholder: "Ingrese el correo electrónico del proveedor",
			},
			documentType: {
				label: "Tipo de documento",
				placeholder: "Seleccione el tipo de documento",
				required: "Tipo de documento requerido",
			},
			documentNumber: {
				label: "Número de documento",
				placeholder: "Ingrese el número de documento",
				required: "Número de documento requerido",
			},
			cpf: {
				label: "CPF",
				placeholder: "Ingrese el CPF del proveedor",
			},
			cnpj: {
				label: "CNPJ",
				placeholder: "Ingrese el CNPJ del proveedor",
			},
			international: {
				label: "Documento internacional",
				placeholder: "Ingrese el documento internacional",
			},
			floorComplement: "Mínimo garantizado por evento",
			featureAlert:
				"El cargo restante solo se distribuirá si el bar principal de la caja registradora que realizó el cargo es del proveedor. Se cobra sobre el impuesto de ventas del cargo restante del proveedor.",
		},
		guidance: {
			vendorData: {
				title: "Editar datos del proveedor",
				description: "Nombre, login y contraseña",
			},
			linkingBarsAndLocations: {
				title: "Editar lugares y bares",
				description: "Seleccione los lugares del proveedor y sus bares",
			},
			feesTaxProfile: {
				title: "Editar tarifas y perfil fiscal",
				description:
					"Tarifas diarias, porcentaje sobre ingresos, porcentaje sobre servicio, día de pago y perfil fiscal",
			},
		},
		productModal: {
			title: "Productos y tarifas especiales",
			product: "Producto",
			fee: "Tarifa",
			closeConfirmTitle: "Descartar cambios en tarifas especiales",
			closeConfirmSubtitle:
				"Ha realizado cambios y solo se guardarán si hace clic en 'guardar cambios'. ¿Desea descartar los cambios realizados o volver a editar las tarifas?",
			closeConfirmCancelActionText: "Volver a editar",
			closeConfirmConfirmActionText: "Descartar cambios",
			save: "Guardar cambios",
			deleteConfirmTitle: "Eliminar tarifa especial",
			deleteConfirmSubtitle: "¿Desea eliminar la tarifa especial de '{{value}}'?",
			deleteConfirmBoldSubtitle: "Esta acción no se puede deshacer",
		},
	},
	modalPermissions: {
		single: {
			edit: "Editar {{vendorName}}",
			withdraw: "Bloquear retiro",
			anticipation: "Permitir solicitud de anticipación",
			financialVendor: "Generar cierres financieros",
			remove: "Eliminar proveedor",
		},
		multiple: {
			title: "{{count}} proveedores seleccionados",
			blockWithdraw: {
				title: "Bloquear retiro",
				subtitle: "Bloquear retiro de {{count}} proveedores",
				description:
					"Esta acción bloqueará el retiro de los proveedores a continuación en todos los lugares.",
				confirm: "Confirmar bloqueo de retiro",
			},
			canAnticipate: {
				title: "Permitir anticipación",
				subtitle: "Bloquear anticipación de {{count}} proveedores",
				description:
					"Esta acción bloqueará la anticipación de los proveedores a continuación en todos los lugares.",
				confirm: "Confirmar bloqueo de anticipación",
			},
			cancel: "Cerrar",
			applySelection: "Aplicar selección",
		},
		thisAction: "Esta acción",
		vendorsBelow: "de los proveedores a continuación en todos los lugares",
		featureTitleBothAllowed: "Permitir retiro y anticipación",
		featureTitleBothBlocked: "Bloquear retiro y anticipación",
		featureTitleMixed: "{{withdraw}} retiro y {{anticipation}} anticipación",
		block: "Bloquear",
		allow: "Permitir",
		vendorsCount_one: "de 01 proveedor",
		vendorsCount_other: "de {{count}} proveedores",
	},
};
